import { render, staticRenderFns } from "./SwitchMyInfo.vue?vue&type=template&id=89dd0e1c&"
import script from "./SwitchMyInfo.vue?vue&type=script&lang=js&"
export * from "./SwitchMyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports